import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Footer = () => {
  const [contactInfo, setContactInfo] = useState(null);

  useEffect(() => {
    fetchContactInfo();
  }, []);

  const fetchContactInfo = async () => {
    try {
      const response = await axios.get(`${API}/contact-info`);
      setContactInfo(response.data);
    } catch (error) {
      console.error('Error fetching contact info:', error);
    }
  };

  return (
    <footer className="bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* About Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <img 
                src="https://customer-assets.emergentagent.com/job_png-emp-assoc/artifacts/df9awda4_PEA%20Logo" 
                alt="PEA PNG Logo" 
                className="h-12 w-auto object-contain"
              />
              <div>
                <h3 className="font-bold text-lg text-white">PEA PNG</h3>
              </div>
            </div>
            <p className="text-gray-400 text-sm">
              Advocating for the rights and welfare of public employees across Papua New Guinea.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">
                  News
                </Link>
              </li>
              <li>
                <Link to="/events" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">
                  Events
                </Link>
              </li>
              <li>
                <Link to="/membership" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">
                  Membership
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Resources</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/resources" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">
                  Documents
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/admin/login" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">
                  Admin Login
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-sm">
                <MapPin size={16} className="text-orange-400 mt-1 flex-shrink-0" />
                <span className="text-gray-400">
                  {contactInfo ? `${contactInfo.city}, ${contactInfo.country}` : 'Port Moresby, Papua New Guinea'}
                </span>
              </li>
              <li className="flex items-center space-x-2 text-sm">
                <Phone size={16} className="text-orange-400 flex-shrink-0" />
                <span className="text-gray-400">{contactInfo ? contactInfo.phone : '+675 XXX XXXX'}</span>
              </li>
              <li className="flex items-center space-x-2 text-sm">
                <Mail size={16} className="text-orange-400 flex-shrink-0" />
                <span className="text-gray-400">{contactInfo ? contactInfo.email : 'info@peapng.org'}</span>
              </li>
            </ul>
            <div className="flex space-x-3 mt-4">
              {contactInfo?.facebook_url && (
                <a href={contactInfo.facebook_url} target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center hover:bg-orange-500 transition-colors">
                  <Facebook size={16} />
                </a>
              )}
              {contactInfo?.twitter_url && (
                <a href={contactInfo.twitter_url} target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center hover:bg-orange-500 transition-colors">
                  <Twitter size={16} />
                </a>
              )}
              {contactInfo?.linkedin_url && (
                <a href={contactInfo.linkedin_url} target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center hover:bg-orange-500 transition-colors">
                  <Linkedin size={16} />
                </a>
              )}
              {!contactInfo?.facebook_url && !contactInfo?.twitter_url && !contactInfo?.linkedin_url && (
                <>
                  <a href="#" className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center hover:bg-orange-500 transition-colors">
                    <Facebook size={16} />
                  </a>
                  <a href="#" className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center hover:bg-orange-500 transition-colors">
                    <Twitter size={16} />
                  </a>
                  <a href="#" className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center hover:bg-orange-500 transition-colors">
                    <Linkedin size={16} />
                  </a>
                </>
              )}
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Public Employees Association of Papua New Guinea. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;